import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvList = async ({ rootGetters, commit }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const csvList = await stbApi.getHubCsvList({}, clientSid);

  commit('setUploadedCsvList', csvList);
  return csvList;
};
